import React from "react"
import Navbar from "../components/NavBar"
import About from "../components/About"
import Footer from "../components/Footer"
import SEO from "../components/Seo"

export default function AboutScreen() {
  return (
    <div>
      <SEO
        title="About"
        description="About InfraDigital Foundation. Lembaga not-for-profit di bidang pengembangan pendidikan di indonesia."
      />
      <Navbar color="blue" />
      <About />
      <Footer />
    </div>
  )
}
